import { RevxButton } from 'components/RevxButton';
import { FilterTabEnum, JobItem } from 'domains/workspaceDomain';
import { useTranslation } from 'react-i18next';
import React from 'react';

type Props = {
  scrollLoading: boolean;
  scrollDetailTab: (e: React.MouseEvent<HTMLElement>) => void;
  data: JobItem;
  setActiveTab: (tab: FilterTabEnum) => void;
};

const CardActionEnterShippingInfoBtn = ({
  data,
  scrollDetailTab,
  scrollLoading,
  setActiveTab,
}: Props) => {
  const { t } = useTranslation();
  if (data.directlyAddToCart) {
    return <></>;
  }
  return (
    <RevxButton
      type="primary"
      loading={scrollLoading}
      onClick={(e) => {
        setActiveTab(FilterTabEnum.SHIPPING_BILLING);
        scrollDetailTab(e);
      }}
      size="large"
    >
      {t('workspace.list.enterShippingInfo')}
    </RevxButton>
  );
};

export default CardActionEnterShippingInfoBtn;
